export function listenForLanguageChange() {
  $('.language-selector .selected').on('click', function(e) {
    e.preventDefault();

    $('.language-selector').toggleClass('open');
  });
}
